import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 
    "lateFee", "noShowFee", "lateTestFee" ]

  connect() {
    
  }

  toggleLateFee() {
    // find lateFee from target
    const lateFee = this.lateFeeTarget;
    // change if lateFee is disabled or enabled
    if(lateFee.disabled) {
      lateFee.disabled = false;
    } else {
      lateFee.disabled = true;
    }
  }

  toggleTestLateFee() {
    const lateTestFee = this.lateTestFeeTarget;
    if(lateTestFee.disabled) {
      lateTestFee.disabled = false;
    } else {
      lateTestFee.disabled = true;
    }
  }

  toggleNoShowFee() {
    // find noShowFee from target
    const noShowFee = this.noShowFeeTarget;
    // change if noShowFee is disabled or enabled
    if(noShowFee.disabled) {
      noShowFee.disabled = false;
    } else {
      noShowFee.disabled = true;
    }
  }

}
